import React, { ReactElement } from 'react';
import { NextPageWithLayout } from 'next';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { useIntl } from 'react-intl';
import markdown from '../data/staticPages/cookies.md';
import Layout from '../components/Layout';
import LinkAndAnchor from '../components/LinkAndAnchor';
import messages from '../lib/messages.json';
import HomeLink from '../components/HomeLink';
import Head from '../components/Head';
import Markdown from '../components/Markdown';

const CookiesPage: NextPageWithLayout = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="cookies"
      passHref
    >
      {intl.formatMessage(messages['cookieConsent.cookies.title'])}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages['cookieConsent.cookies.title'])}
        description={
          intl.formatMessage(messages['cookieConsent.cookies.title'])
        }
      />
      <StaticPageComponent
        content={<Markdown markdown={markdown} />}
        title={intl.formatMessage(messages['cookieConsent.cookies.title'])}
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};

CookiesPage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

export default CookiesPage;
